__turbopack_context__.v({
  "ask": "DecisionsView-module__CfApbq__ask",
  "askButton": "DecisionsView-module__CfApbq__askButton",
  "askStage": "DecisionsView-module__CfApbq__askStage",
  "card": "DecisionsView-module__CfApbq__card",
  "row": "DecisionsView-module__CfApbq__row",
  "rowLineWait": "DecisionsView-module__CfApbq__rowLineWait",
  "rowLit": "DecisionsView-module__CfApbq__rowLit",
  "rowOpen": "DecisionsView-module__CfApbq__rowOpen",
  "rowShow": "DecisionsView-module__CfApbq__rowShow",
  "title": "DecisionsView-module__CfApbq__title",
  "when": "DecisionsView-module__CfApbq__when",
  "who": "DecisionsView-module__CfApbq__who",
});
